export default class CanvasGrid {

  constructor(width, height, cols, rows, options) {
    this.width = width;
    this.height = height;
    this.cols = cols;
    this.rows = rows;
    this.x = options.x || 0;
    this.y = options.y || 0;
    this.context = options.context;
    this.drawOptions = options.draw || {};

    this.generatePoints();
  }

  generatePoints() {
    // Very hard calculations
    this.colSpace = this.width / this.cols;
    this.rowSpace = this.height / this.rows;
    this.gridPoints = [];

    for(let col = 0; col <= this.cols; col++) {
      for(let row = 0; row <= this.rows; row++) {
        let x = this.x + col * this.colSpace;
        let y = this.y + row * this.rowSpace;
        this.gridPoints.push({x,y});
      }
    }
  }

  update(options, objects) {
    let cols = options.cols || this.cols;
    let rows = options.rows || this.rows;
    let sf = options.snapFree !== undefined ? options.snapFree : true;

    this.forceSnap = !sf;
    this.doSnap = options.doSnap || false;

    this.cols = cols;
    this.rows = rows;
    this.generatePoints();

    objects.forEach(object => {
      if(object.constraints && object.constraints.snap === this) {
        object.constraints.snap = this;
        object.constraints.snapFree = !this.forceSnap;
        object.constraints.doSnap = this.doSnap;
        object.calulations();
      }
    });
  }

  draw() {
    const c = this.context;

    c.save();

    // c.fillStyle = this.drawOptions.fill || 'white';
    c.strokeStyle = 'white';
    c.lineWidth = 2;
    if(this.drawOptions.stroke) {
      let s = this.drawOptions.stroke.split(" ");
      c.strokeStyle = s[0];
      c.lineWidth = s[1];
    }

    c.globalCompositeOperation = 'destination-over';

    // Code to draw the grid
    // Start with the borders
    // c.beginPath();
    // c.moveTo(this.x, this.y);
    // c.lineTo(this.x + this.width, this.y);
    // c.lineTo(this.x + this.width, this.y + this.height);
    // c.lineTo(this.x, this.y + this.height);
    // c.closePath();
    // c.stroke();

    // Then do the cols
    c.beginPath();
    for(let col = 0; col <= this.cols; col++) {
      let x = this.x + col * this.colSpace;
      c.moveTo(x, this.y);
      c.lineTo(x, this.y + this.height);
    }
    c.stroke();

    // And finally the rows
    c.beginPath();
    for(let row = 0; row <= this.rows; row++) {
      let y = this.y + row * this.rowSpace;
      c.moveTo(this.x, y);
      c.lineTo(this.x + this.width, y);
    }
    c.stroke();


    c.restore();

  }

}



// WEBPACK FOOTER //
// ./src/components/canvas/CanvasGrid.js